'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaPiedPiper = function FaPiedPiper(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.3 22.8q0 1.4-0.8 2.4t-2 1q-1 0-1.6-0.3v-6.2q0.6-0.4 1.6-0.4 1.2 0 2 1t0.8 2.5z m-7.6-9.6q0 1.4-0.9 2.5t-2 1q-0.9 0-1.5-0.4v-6.1q0.6-0.4 1.5-0.4 1.2 0 2 1t0.9 2.4z m12.5 9.6q0-3-1.9-5.1t-4.8-2.1q-0.4 0-0.9 0.1-0.5 1.7-1.7 3-1.9 2.1-4.7 2.3v14.2l4.7-1v-4.6q1.1 0.5 2.6 0.5 2.8 0 4.8-2.2t1.9-5.1z m-7.6-9.5q0-3-2-5.1t-4.8-2.1q-1.6 0-3.1 0.8h-4.2v18.7l4.8-0.9v-4.6q1.2 0.4 2.5 0.4 2.8 0 4.8-2.1t2-5.1z m13.7-4v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
        )
    );
};

exports.default = FaPiedPiper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/pied-piper.js
// module id = 1420
// module chunks = 0